<template>
    <v-expansion-panels v-model="filtersExpanded" class="filters-wrapper" elevation="0">
        <v-expansion-panel>
            <div class="filters-wrapper__header d-flex align-center justify-space-between">
                <v-expansion-panel-title class="width-auto text-primary">
                    {{ $t('filters') }}
                    <template v-if="hasActiveFilters && filtersExpanded !== 0">
                        <v-badge class="ml-2 mb-3" color="primary" dot />
                    </template>
                </v-expansion-panel-title>
                <slot name="panel" />
            </div>
            <v-expansion-panel-text>
                <div class="table-filters">
                    <slot />
                </div>
                <v-row no-gutters class="gc-2 gr-2 align-center pb-2">
                    <v-btn class="reset-btn" color="inherit" variant="text" data-cy="reset" @click="emit('reset')">
                        {{ $t('reset') }}
                    </v-btn>
                    <v-btn class="filter-btn" color="primary" data-cy="submit" @click="emit('submit')">
                        {{ $t('filter') }}
                    </v-btn>
                    <slot name="actions" />
                </v-row>
            </v-expansion-panel-text>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script setup lang="ts">
    const {isExpanded = false} = defineProps<{
        hasActiveFilters: boolean
        isExpanded?: boolean
    }>()

    const filtersExpanded = ref<number | undefined>()

    onMounted(async () => {
        if (isExpanded) filtersExpanded.value = 0
    })

    const emit = defineEmits<{
        (e: 'reset' | 'submit'): void
    }>()
</script>
